module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tree', {
    staticClass: "tree",
    attrs: {
      "data": _vm.treeData,
      "layoutType": "radial",
      "type": "cluster",
      "duration": 50,
      "nodeText": "name",
      "margin-x": 0,
      "margin-y": 0,
      "person": _vm.selectedPerson,
      "ramp": "interpolateYlGnBu",
      "data-step": "2",
      "data-intro": "This is a phylogeny of all bird families.\n You can click on the names to learn more about them! Try it!"
    },
    on: {
      "clicked": _vm.clicked
    }
  }), _c('div', {
    staticClass: "ui raised container segment"
  }, [_c('my-header', {
    attrs: {
      "main": _vm.selectedLeaf ? _vm.selectedLeaf : 'Select a familiy to begin!',
      "sub": _vm.common
    }
  }), (_vm.selectedTree === 'bird') ? _c('div', {
    staticClass: "ui divider"
  }) : _vm._e(), (_vm.selectedTree === 'bird') ? _c('table', {
    staticClass: "ui center aligned single line table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Total in Family")]), _c('th', {
    class: [_vm.selectedPerson == 'corey' ? 'positive' : ''],
    attrs: {
      "data-step": "4",
      "data-intro": "You can color the tips by the proportion of bird species seen in that family!"
    },
    on: {
      "click": function($event) {
        _vm.recolor('corey')
      }
    }
  }, [_vm._v("Corey ")]), _c('th', {
    class: [_vm.selectedPerson == 'jim' ? 'positive' : ''],
    on: {
      "click": function($event) {
        _vm.recolor('jim')
      }
    }
  }, [_vm._v("Jim")]), _c('th', {
    class: [_vm.selectedPerson == 'will' ? 'positive' : ''],
    on: {
      "click": function($event) {
        _vm.recolor('will')
      }
    }
  }, [_vm._v("Will")])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.people.sp_count))]), _c('td', [_vm._v(_vm._s(_vm.people.corey))]), _c('td', [_vm._v(_vm._s(_vm.people.jim))]), _c('td', [_vm._v(_vm._s(_vm.people.will))])])])]) : _vm._e(), (_vm.selectedLeaf) ? _c('div', {
    staticClass: "ui horizontal divider",
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Summary")]) : _vm._e(), _c('wiki-summary', {
    attrs: {
      "selected": _vm.selectedLeaf
    }
  })], 1), _c('attribution')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37d49db0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PhyloTree.vue
// module id = 237
// module chunks = 1